/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetRemarksTemplateRequest
 */
export interface RequestGetRemarksTemplateRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestGetRemarksTemplateRequest
     */
    baseId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetRemarksTemplateRequest
     */
    tenantId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetRemarksTemplateRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestGetRemarksTemplateRequest interface.
 */
export function instanceOfRequestGetRemarksTemplateRequest(value: object): value is RequestGetRemarksTemplateRequest {
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestGetRemarksTemplateRequestFromJSON(json: any): RequestGetRemarksTemplateRequest {
    return RequestGetRemarksTemplateRequestFromJSONTyped(json, false);
}

export function RequestGetRemarksTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetRemarksTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
    };
}

export function RequestGetRemarksTemplateRequestToJSON(json: any): RequestGetRemarksTemplateRequest {
    return RequestGetRemarksTemplateRequestToJSONTyped(json, false);
}

export function RequestGetRemarksTemplateRequestToJSONTyped(value?: RequestGetRemarksTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

